import fp from 'lodash/fp';
import React, { Component } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { compose, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { cpdCategorysActions } from '../../../../state/modules/areas-of-advice';
import { publishersSelector } from '../../../../state/modules/publisher-portal/publisher/selectors';
import { Icon, PublisherFilterGroup, SearchToggler } from '../../../components';
import EventTable from './event-table';

/**
 * Shared library for displaying the events along with their filters. 
 */
class PublishedEvents extends Component {

  constructor() {
    super();

    this.state = {
      currentSorting: '',
      searchQuery: '',
      searchDebounce: null
    };
  }

  onSearchChange = (query, debounced) => ({
    searchQuery: query,
    searchDebounce: debounced
  })

  searchEvents = (query) => {
    const debounced = fp.debounce(500)(() => {
      this.props.getEvents(0, this.eventQuery(this.state.currentSorting, this.state.searchQuery, this.props.filters.status, this.props.filters.publisherName, this.props.filters.goalIds));
    });
    this.state.searchDebounce && this.state.searchDebounce.cancel();
    this.setState(this.onSearchChange(query, debounced))
    debounced();
  }

  componentDidMount() {
    if (this.props.cpdCategorys.length === 0 && !this.props.isFetching) {
      this.props.getCpdCategorys();
    }
    this.props.getEvents(0, this.eventQuery(this.state.currentSorting, this.state.searchQuery, this.props.filters.status, this.props.filters.publisherName, this.props.filters.goalIds));
  }

  componentDidUpdate(prevProps) {
    const {
      getEvents,
      filters
    } = this.props
    if (!fp.isEqual(filters)(prevProps.filters)) {
      getEvents(
        0,
        this.eventQuery(
          this.state.currentSorting,
          this.state.searchQuery,
          filters.status,
          filters.publisherName,
          filters.goalIds
        )
      )
    }
  }

  eventQuery(sorting, searchQuery, status, publisher, goalIds) {
    const cpdCategorys = fp.join(',')(this.props.filters.cpdCategoryIds)
    return {
      cpdCategorys,
      sort: sorting,
      titleTags: searchQuery,
      status: status,
      take: 50,
      publisherName: publisher,
      eventType: this.props.eventType,
      goals: fp.join(',')(goalIds)
    };
  }

  loadMoreEvents(e) {
    this.props.loadMoreEvents(this.props.eventsResult.events.length, this.eventQuery(this.state.currentSorting, this.state.searchQuery, this.props.filters.publisherName, this.props.filters.goalIds));
  }

  sortBy(field, sortOrder) {
    const sortParam = sortOrder ? `${field},${sortOrder}` : '';
    this.setState({
      currentSorting: sortParam
    });
    this.props.getEvents(0, this.eventQuery(sortParam, this.state.searchQuery, this.props.filters.status, this.props.filters.publisherName, this.props.filters.goalIds));
  }

  render() {
    const { eventType } = this.props;
    return (
      <div className='base-layout'>
        <section id='header--publishers' className='layout--header'>
          <Grid>
            <Row className='button-gutter'>
              <Col xs={12}>
                <h1><Icon icon='caddie-links-large-alt' /> Your {eventType}s</h1>
                <p>Add or manage {eventType}s.</p>
                <p>
                  <LinkContainer className='large auto-large pushLeft' to={this.props.eventDetailsRoute}>
                    <Button>
                      <Icon icon='add-large' /> Add {eventType}
                    </Button>
                  </LinkContainer>
                </p>
              </Col>
            </Row>
          </Grid>
        </section>
        <div id='section--publishers' className='layout--section'>
          <Grid>
            <section id='publishers--content'>
              <div className="accordion--search bottom-gap">
                <Row className='button-gutter'>
                  <Col xs={12} className='flexbox nowrap'>
                    <span className='right-gap'>
                      <SearchToggler onChange={this.searchEvents} />
                    </span>
                    <PublisherFilterGroup onApply={this.props.setFilters} />
                  </Col>
                </Row>
              </div>
              <div className='content-result-summary'>
                <div>
                  <b>{this.props.eventsResult.hits}</b>
                  &nbsp;
                  {this.props.eventsResult.hits === 1 ? 'record' : 'records'}
                </div>
              </div>
              <EventTable
                eventType={eventType}
                eventsResult={this.props.eventsResult}
                isFetchingEvents={this.props.isFetchingEvents}
                isFetching={this.props.isFetching}
                eventEditRoute={this.props.eventEditRoute}
                getEvents={this.props.getEvents}
                deleteEvent={this.props.deleteEvent}
                currentEventQuery={this.eventQuery(this.state.currentSorting, this.state.searchQuery)}
                allowDelete={this.props.allowDelete}
                updateBySorting={this.sortBy.bind(this)} />
            </section>
            {
              this.props.eventsResult.events.length < this.props.eventsResult.hits ?
                <Row className='no-gutter row-slider no-background'>
                  <Col xs={12} md={4} mdOffset={4}>
                    <Button className='large full' onClick={(e) => this.loadMoreContent(e)}>
                      Load More Events
                    </Button>
                  </Col>
                </Row> :
                null
            }
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cpdCategorys: state.cpdCategorys.cpdCategorys,
  isFetching: state.cpdCategorys.isFetching,
  publishers: publishersSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
  getCpdCategorys: bindActionCreators(cpdCategorysActions.cpdCategorys.get, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      filters: {}
    },
    {
      setFilters: () => (filters) => ({ filters })
    }
  ),
  withProps(
    ({
      filters,
      publishers
    }) => {
      const publisherName = fp.flow(
        fp.find(
          ({ id }) => id === filters.publisher
        ),
        fp.get('name')
      )(publishers)
      return {
        filters: {
          ...filters,
          publisherName
        }
      }
    }
  )
)(PublishedEvents);



// WEBPACK FOOTER //
// ./src/containers/pages/shared/publish-event/events.js